import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { API } from "./App";
import { getAuthHeader } from "./AuthRoute";
import ExcelUploadModal from "./ExcelUploadModal";
import ExportSondagesButton from "./ExportSondagesButton";

function AllSondagesTable() {
  const navigate = useNavigate();
  const { pageNbr } = useParams();
  const [sondages, setSondages] = useState([]);
  const [page, setPage] = useState(pageNbr ? pageNbr - 1 : 0);
  const [pageSize, setPageSize] = useState(5);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  useEffect(() => {
    loadSondages();
  }, [page, pageSize]);

  function loadSondages() {
    setLoading(true);
    fetch(API() + "/sondages?page_index=" + page + "&page_size=" + pageSize, {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => {
        setTotalRecords(data.total_records);
        setSondages(data.page_sondages);
        setLoading(false);
      })
      .catch((err) => {
        setSondages([]);
        setLoading(false);
        alert("Error: " + err.message);
      });
  }

  const sondageUrlTemplate = (rowData) => (
    <a href={rowData.sondage_url} target="_blank" rel="noopener noreferrer">
      {rowData.sondage_url}
    </a>
  );

  const pdfsTemplate = (rowData) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.2rem" }}>
      {rowData.documents.map((doc, i) => (
        <a key={i} href={doc.pdf_url} target="_blank" rel="noopener noreferrer">
          {doc.filename || doc.pdf_url}
        </a>
      ))}
    </div>
  );

  return (
    <div className="card">
      <h3 style={{ padding: "10px" }}>All Sondages ({totalRecords} docs)</h3>

      <div
        style={{
          marginBottom: "1rem",
          background: "#f9f9f9",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <div style={{ marginBottom: "1rem" }}>
          Format:
          <pre>
            sondage_url sondage_name x y lien_pdf lien_pdf2 lien_pdf3 lien_pdf4
          </pre>
        </div>
        <b>Field explanations:</b>
        <ul>
          <li>
            <b>sondage_url:</b> Matches the <i>\"Lien\"</i> column of the Excel
            import and shows a small preview in the right-side popup.
          </li>
          <li>
            <b>sondage_name:</b> Name/title of the sondage.
          </li>
          <li>
            <b>x, y:</b> Coordinates of the sondage.
          </li>
          <li>
            <b>PDFs (lien_pdf etc.):</b> PDF documents related to the sondage,
            shown as quick navigation links in the left-side popup. At least one
            PDF is required.
          </li>
        </ul>
      </div>

      <Button
        label="Import Sondages (Excel)"
        icon="pi pi-upload"
        style={{ marginBottom: "10px", marginRight: "10px" }}
        onClick={() => setShowUploadDialog(true)}
      />

      <ExportSondagesButton />

      <ExcelUploadModal
        visible={showUploadDialog}
        onHide={() => setShowUploadDialog(false)}
        onSuccess={loadSondages}
      />

      <DataTable
        value={sondages}
        responsiveLayout="scroll"
        paginator
        rows={pageSize}
        first={page * pageSize}
        totalRecords={totalRecords}
        lazy
        onPage={(e) => {
          setPage(e.page);
          setPageSize(e.rows);
          navigate(`/all-sondages/${e.page + 1}`);
        }}
        loading={loading}
        rowsPerPageOptions={[5, 10, 20, 50, 100]}
        showGridlines
      >
        <Column body={sondageUrlTemplate} header="Sondage URL" />
        <Column field="sondage_name" header="Sondage Name" />
        <Column field="position.x" header="X" />
        <Column field="position.y" header="Y" />
        <Column body={pdfsTemplate} header="PDFs" />
      </DataTable>
    </div>
  );
}

export default AllSondagesTable;
